module.exports = __webpack_public_path__ + "img/80.1e95520.png";